import Vue from 'vue'
import Vuex from 'vuex'
import strapi from './strapi'
import strapiBlog from './strapiBlog'
import app from './app'
import strapiv2 from './strapiv2'
import project from './project'
import { v4 as uuidv4 } from 'uuid';

import version from '../version'
import K from '../K'

Vue.use(Vuex)

let uid = localStorage.getItem('uid') 
if (!uid) {
  uid = uuidv4()
  localStorage.setItem(K.userId, uid)
}

export default new Vuex.Store({
  state: {
    version: version.version || '0.0.0',
    versionCommit: version.commit || '---',
    uid: uid,
    contactTitle: '',
    contactShowIt: false
  },
  getters: {
    uid: state => state.uid,
    version: state => state.version,
    versionCommit: state => state.versionCommit
  },
  mutations: {
    showContact (state, args) {
      if (args.from === 'left' && args.path === '/mon-projet') {
        return
      }
      state.contactTitle = args && args.title ? args.title : 'Nous contacter'
      state.contactShowIt = true
    },
    hideContact (state) {
      state.contactShowIt = false
    },
  },
  actions: {
  },
  modules: {
    strapi,
    strapiBlog,
    app,
    strapiv2,
    project
  }
})
